document.addEventListener('DOMContentLoaded', function() {

  const triggers = document.querySelectorAll('[data-drawer-trigger]');
  const overlay = document.querySelector('.drawer-overlay');
  const closeBtns = document.querySelectorAll('[data-drawer-close]');

  function closeDrawer() {
    document.querySelectorAll('.custom-drawer').forEach(drawer => {
      drawer.classList.remove('active');
    });

    overlay.classList.remove('active');
    document.body.classList.remove('no-scroll');
  }

  // Open drawer
  triggers.forEach(trigger => {
    trigger.addEventListener('click', function() {
      const drawerId = this.dataset.drawerTrigger;
      const drawer = document.getElementById(drawerId);

      if (drawer) {
        drawer.classList.add('active');
        overlay.classList.add('active');
        document.body.classList.add('no-scroll');
      }
    });
  });

  // Close drawer buttons
  closeBtns.forEach(btn => {
    btn.addEventListener('click', closeDrawer);
  });

  // NEW: close drawer when Ask Question link is clicked
  document.querySelectorAll('.open-ask-question').forEach(el => {
    el.addEventListener('click', function() {
      closeDrawer();
    });
  });

});